import xml2js from 'xml2js';
import { sendHttpRequest } from '../utilities/sendHttpRequest';
import getConfig from 'next/config';
import datadogRumClient from '../../utils/datadog-rum';

const { publicRuntimeConfig } = getConfig();

export const USPS_URL =
  'https://secure.shippingapis.com/ShippingAPI.dll?API=Verify&XML=';

interface ValidateAddressArgs {
  address: {
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
  };
}
async function validateAddress({ address }: ValidateAddressArgs) {
  let xml = `<AddressValidateRequest USERID='${publicRuntimeConfig.uspsAPIUserID}'><Address><Address1>${address.address2}</Address1><Address2>${address.address}</Address2><City>${address.city}</City><State>${address.state}</State><Zip5>${address.zip}</Zip5><Zip4></Zip4></Address></AddressValidateRequest>`;

  try {
    const response = await sendHttpRequest({
      method: 'get',
      url: USPS_URL + xml,
      headers: { 'Content-Type': 'text/xml' },
      validateResponse: () => true,
      retries: 2,
      backoffMs: 500
    });

    return await new Promise(resolve =>
      xml2js.parseString(response.request.responseText, function (err, result) {
        const correctedAddress = result.AddressValidateResponse.Address[0];
        if (correctedAddress.Error) {
          resolve({
            addressNotFound: true
          });
        }
        resolve({
          address: correctedAddress.Address2[0],
          address2: correctedAddress.Address1
            ? correctedAddress.Address1[0]
            : '',
          city: correctedAddress.City[0],
          state: correctedAddress.State[0],
          zip: correctedAddress.Zip5[0]
        });
      })
    );
  } catch (error) {
    datadogRumClient.addAction('Failed to validate address', {
      error
    });
    return false;
  }
}

export default {
  validateAddress
};
